import React, { useEffect, useState, useContext, useRef } from "react";
import { RiCloseFill } from "react-icons/ri";
import { FaHeart } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import Loader2 from '../../DashboardComponents/Loader/Loader2';

import CameraModal from "../../DashboardComponents/ImageUpload/CameraModel.js";

import { updatewhiteironimages, updateirontestdata } from "../../../Api/contact";

import { ForwardFittingContext } from "../ForwardFittingContext.js";

import { API_URL } from "../../../Api/config.js";
import { FaCheck } from "react-icons/fa6";
import { getCurrentUser } from "../../../Api/auth.js";
import { IoClose } from "react-icons/io5";

const IronData = ({ remoteData, projectid }) => {
  const { remotefittingdata, setRemotefittingdata, updateremotefitting } =
    useContext(ForwardFittingContext);
  const [isOpen, setIsOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);


  const colors = [
    {
      name: "White",
      isOpen: true,
      ironClass: "white",
      ironColor: "#ffffff",
      ironLabel: "White",
      ironLabel2: "White",
      ironLabel3: "White Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "whiteiron"
    },
    {
      name: "Black",
      isOpen: true,
      ironClass: "black",
      ironColor: "#ffffff",
      ironLabel: "Black",
      ironLabel2: "Black",
      ironLabel3: "Black Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "blackiron"
    },
    {
      name: "Blue",
      isOpen: true,
      ironClass: "blue",
      ironColor: "#ffffff",
      ironLabel: "Blue",
      ironLabel2: "Blue",
      ironLabel3: "Blue Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "blueiron"
    },
    {
      name: "Pink",
      isOpen: true,
      ironClass: "pink",
      ironColor: "#ffffff",
      ironLabel: "Pink",
      ironLabel2: "#f73aec",
      ironLabel3: "Pink Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "pinkiron"
    },
    {
      name: "Purple",
      isOpen: true,
      ironClass: "purple",
      ironColor: "#ffffff",
      ironLabel: "Purple",
      ironLabel2: "#a300ff",
      ironLabel3: "Purple Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "purpleiron"

    },
    {
      name: "Red",
      isOpen: true,
      ironClass: "red",
      ironColor: "#ffffff",
      ironLabel: "Red",
      ironLabel2: "Red",
      ironLabel3: "Red Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "rediron"
    },
    {
      name: "Orange",
      isOpen: true,
      ironClass: "orange",
      ironColor: "#ffffff",
      ironLabel: "Orange",
      ironLabel2: "Orange",
      ironLabel3: "Orange Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "orangeiron"
    },
    {
      name: "Green",
      isOpen: true,
      ironClass: "green",
      ironColor: "#ffffff",
      ironLabel: "Green",
      ironLabel2: "#99ea24",
      ironLabel3: "Green Iron",
      image1: "",
      image2: "",
      image3: "",
      preferredClub: "",
      ironKey: "greeniron"
    },
  ];


  const [ironData, setIronData] = useState(colors);

  const [currentIron, setCurrentIron] = useState(null);

  const [currentCameraData, setCurrentCameraData] = useState(null);

  const [ironDataModal, setIronDataModal] = useState(false);
  const [showCameraModal, setShowCameraModal] = useState(false);
  const [ironDataButtonStatus, setIronDataButtonStatus] = useState(true);

  useEffect(() => {
    // Map through the colors array and replace the values from mongoData based on ironKey

    console.log("the remoteData", remoteData);
    const updatedIronData = colors.map(color => {
      const mongoIron = remoteData?.irondata?.[color.ironKey];
      console.log("mongoIron", mongoIron);
      if (mongoIron) {
        return {
          ...color,
          name: mongoIron?.name,
          image1: mongoIron?.iron1?.cameraimage,
          image2: mongoIron?.iron2?.cameraimage,
          image3: mongoIron?.iron3?.cameraimage,
          preferredClub: mongoIron?.preferred_club,
          isOpen: mongoIron?.isopen
        };
      }
      return color; // return original if no corresponding mongo data found
    });

    setIronData(updatedIronData);
    setIronDataButtonStatus(remoteData?.irondata?.status);
  }, [remoteData]);


  const handleCameraModalClose = () => {
    setShowCameraModal(false);
  };

  const handleCameraModalShow = (ironId, ironTitle, color, iron) => {
    setShowCameraModal(true);
    setCurrentCameraData({
      ironid: ironId,
      irontitle: ironTitle,
      ironLabel: color,
      title: iron,
    });
  };

  const handleIronDataPopupHide = () => {
    setScrollPosition(scrollPosition);
    setCurrentIron(null);
  };

  const handleCloseModal = () => {
    //window.scrollTo(0, scrollPosition);
    setCurrentIron(null);
    setIronDataModal(false);
  };


  const updatePhotoInBox = (imageSrc, ironid) => {

    if (ironid === 1) {
      setIronData(prevIronData =>
        prevIronData.map(color => {
          return color.ironClass === currentIron.ironClass
            ? { ...color, image1: imageSrc }
            : color;
        })
      );
    }
    else if (ironid == 2) {
      setIronData(prevIronData =>
        prevIronData.map(color => {
          return color.ironClass === currentIron.ironClass
            ? { ...color, image2: imageSrc }
            : color;
        })
      );
    } else if (ironid == 3) {
      setIronData(prevIronData =>
        prevIronData.map(color => {
          return color.ironClass === currentIron.ironClass
            ? { ...color, image3: imageSrc }
            : color;
        })
      );
    } else {

    }
  };


  const updatePreferredClub = (value) => {
    setIronData(prevIronData =>
      prevIronData.map(color => {
        return color.ironClass === currentIron.ironClass
          ? { ...color, preferredClub: value }
          : color;
      })
    );
  }


  useEffect(() => {
    if (currentIron != null) {
      const whiteIron = ironData.find(color => color.ironClass == currentIron.ironClass);
      setCurrentIron({
        ironClass: whiteIron.ironClass,
        ironColor: whiteIron.ironColor,
        ironLabel: whiteIron.ironLabel,
        ironLabel2: whiteIron.ironLabel2,
        ironLabel3: whiteIron.ironLabel3,
        image1: whiteIron.image1,
        image2: whiteIron.image2,
        image3: whiteIron.image3,
        preferredClub: whiteIron.preferredClub,
        ironKey: whiteIron.ironKey
      });
    }
    console.log("iron data", ironData);
  }, [ironData]);


  const handleSaveIron = async (ironName, key) => {
    setIsLoading(true);
    const ironObject = ironData.find(color => color.ironClass === ironName);

    const formData = new FormData();

    // Function to append image to formData
    function appendImageToFormData(image, fieldName) {
      if (image instanceof File) {
        formData.append(fieldName, image);
      } else if (typeof image === "string" && image.startsWith("data:image/")) {
        // For base64 image, convert to Blob and append to formData
        const base64Data = image.split(",")[1];
        const byteString = atob(base64Data);
        const mimeType = image.match(/data:(.*?);base64,/)[1];
        const arrayBuffer = new Uint8Array(byteString.length);

        for (let i = 0; i < byteString.length; i++) {
          arrayBuffer[i] = byteString.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], { type: mimeType });
        formData.append(fieldName, blob, `${fieldName}.jpg`);
      }
    }

    // Append images to formData
    appendImageToFormData(ironObject.image1, "image1");
    appendImageToFormData(ironObject.image2, "image2");
    appendImageToFormData(ironObject.image3, "image3");

    // Append preferredClub
    formData.append("preferredClub", ironObject.preferredClub);
    formData.append("project_id", projectid);

    formData.append("ironkey", ironObject.ironKey);
    if (key == "greeniron") {
      formData.append("saveIronStatus", true);
    }



    updatewhiteironimages(formData)
      .then((data) => {
        if (data?.code === 200) {
          if (data.data.status === false) {
            console.log("Status is false.");
          } else {
            console.log("Images updated successfully.", data.data.data.remotefittingdata);
            setRemotefittingdata(data.data.data.remotefittingdata);
            handleCloseModal();
          }
        } else {
          console.log(data.data?.message);
        }
      })
      .catch((err) => {
        console.log("Error:", err);
      }).finally(() => {
        setIsLoading(false);
      });

  }

  useEffect(() => {
    console.log("remotefittingdata123", remoteData);
  }, [remoteData]);


  const savetoirontest = () => {
    setIsLoading(true);
    const data = {
      project_id: projectid
    }

    updateirontestdata(data).then((data) => {
      if (data?.code === 200) {
        // setRemotefittingdata(data.data);
        if (data.data.status === false) {
          console.log("status");
        } else {
          console.log(data.data);
          setRemotefittingdata(data?.data?.data?.remotefittingdata);
        }
      } else {
        console.log(data.data);
      }
    }).catch((err) => {
      console.log(err);
    }).finally(() => {
      setIsLoading(false);
    })
  }

  const getfullpath = (path) => {

    if (typeof path == "string" && path.startsWith("data:image/")) {
      console.log("getfullpath1", path);
      return path;
    } else {
      console.log("getfullpath2", path);
      return `${API_URL}remotefittingimage/${path.swing0}`;
    }
  }


  useEffect(() => {

    const squareDivs = document.querySelectorAll('.drop-box-xyz');

    squareDivs.forEach((squareDiv) => {
      // Get the width of each div
      const divWidth = squareDiv.offsetWidth;
      // setHeight(divWidth); // Assuming setHeight is a valid function in your context

      // Set the height to match the width (making it square)
      squareDiv.style.height = divWidth + 'px';
      console.log('Div width:', divWidth);
    });
    // window.addEventListener("resize", checkDevice);
    // return () => {
    //     window.removeEventListener("resize", checkDevice);
    // };
  }, [currentIron]);

  useEffect(() => {
  }, [currentIron]);

  useEffect(() => {
    if (!ironDataModal) {
      // When modal closes, restore scroll position
      window.requestAnimationFrame(() => {
        window.scrollTo(0, scrollPosition);
      });
    }
  }, [ironDataModal, scrollPosition]);

  useEffect(() => {
    if (ironDataModal) {
      // Store current scroll position
      // setScrollPosition(window.scrollY);
      document.querySelector('.remotefittingnewdesign').classList.add('modal-open');
    } else {
      // Cleanup when modal closes
      const cleanup = () => {
        document.querySelector('.remotefittingnewdesign')?.classList.remove('modal-open');
        document.body.style.removeProperty('position');
        document.body.style.removeProperty('width');
        document.body.style.removeProperty('height');
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('--vh');

        // Restore scroll position
        window.scrollTo(0, scrollPosition);
      };

      cleanup();
    }

    return () => {
      // Cleanup on component unmount
      document.querySelector('.remotefittingnewdesign')?.classList.remove('modal-open');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('width');
      document.body.style.removeProperty('height');
      document.body.style.removeProperty('overflow');
      document.documentElement.style.removeProperty('--vh');
    };
  }, [ironDataModal]);

  const handleIronDataPopupShow = (data) => {
    // setScrollPosition(window.scrollY);
  }

  useEffect(() => {
    console.log('scrollPosition-text', scrollPosition);
  }, [scrollPosition]);


  const [role_id, seRole_id] = useState(null);

  useEffect(() => {
    const getCurrentUserdata = getCurrentUser();
    // setUserdata(getCurrentUserdata.user);
    // setUser_id(getCurrentUserdata.user._id);


    if (getCurrentUserdata && getCurrentUserdata.user) {
      seRole_id(getCurrentUserdata.user.role_id);
    } else {
      console.error("Current user data is null or undefined");
    }

  }, []);


const playerRefs = useRef([]);
const [ironDataModal1, setIronDataModal1] = useState(false);
const handleCloseModal1 = () => {
  setIronDataModal1(false);
};


  return (
    <>

      {
        isLoading == true ? (<><Loader2 /></>) : (<>

          <div
            className="row black_bg_box cf mx-3 mt-4 hihahaha"
            style={{
              borderRadius: "40px",
              backgroundColor: "rgb(30, 32, 37)",
              pointerEvents: remoteData?.irondata?.status == true ? "none" : "auto",
            }}
          >
            <div className="club-fitting-card new-m">
              <div className="gab_title mb-0">
                <div className="collapsed d-flex align-items-center">
                  <div className="gab_icon m-0" style={{
                    backgroundColor: remoteData.irondata.status ? "#99ea24" : "",
                  }}>
                    <FaCheck />
                  </div>
                  <div className="gab_text ms-3"><h5 className='cf-title'>Iron Test</h5></div>
                </div>
              </div>
              {
                role_id == 4 && (<div className='gab_text' style={{ fontSize: '20px' }}>
                  It’s time to start testing irons. Watch the tutorial below to get an overview of how to go through the fitting process.
                </div>)
              }
              {/* <div className='gab_text' style={{ fontSize: '20px' }}>
                It’s time to start testing irons. Watch the tutorial below to get an overview of how to go through the fitting process.
              </div> */}
            </div>


            {
              role_id == 4 && (<div className="col-12 my-4 w-full">
                <div eventkey="2" className="mobile-accordion" onClick={() => setIronDataModal1(true)}>
                  <div
                    className="bg_green_light"
                    style={{ backgroundColor: "rgb(54, 69, 79)" }}
                  >
                    <div className="gs_fr_tops" id="lesson_card_1">
                      <div>
                        <div className="gab_title">
                          <div className="gab_text bg-accordion-title">
                            <h5>How Iron Testing Works</h5>
                          </div>
                          <div className="">
                            <div className="barplay_icon_item">
                              <FaEye size={15} color="#ffffff" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)
            }

            {/* <div className="col-12 mt-5 w-full">
              <div eventkey="2" className="mobile-accordion">
                <div
                  className="bg_green_light"
                  style={{ backgroundColor: "rgb(54, 69, 79)" }}
                >
                  <div className="gs_fr_tops" id="lesson_card_1">
                    <div>
                      <div className="gab_title">
                        <div className="gab_text bg-accordion-title">
                          <h5>How Iron Testing Works</h5>
                        </div>
                        <div className="">
                          <div className="barplay_icon_item">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth="0"
                              viewBox="0 0 448 512"
                              color="#ffffff"
                              height="15"
                              width="15"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{ color: "rgb(255, 255, 255)" }}
                            >
                              <path d="M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {ironData.map((color, index) => (
              <div key={index} className={`circle-color d-flex align-items-center justify-content-between mb-2 ${color.ironClass == "white" ? "" : ""}`
              }
              >
                <div
                  className={`gab_text ${color.name ? color.name.toLowerCase() : "default"}_box d-flex align-items-center`}
                >
                  <span className="color me-5"></span>
                  <p style={{ fontSize: "24px", fontWeight: "800" }}>
                    {color.ironLabel}
                  </p>
                </div>
                <button
                  className="btn open-btn py-3"
                  style={{
                    backgroundColor: color.isOpen
                      ? "rgb(153, 234, 36)"
                      : "rgb(58, 66, 78)",
                    color: color.isOpen ? undefined : "rgb(107, 114, 126)",
                    border: color.isOpen ? "none" : "2px solid green",
                  }}
                  disabled={!color.isOpen}
                  onClick={(event) => {
                    event.preventDefault();

                    const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
                    setScrollPosition(window.scrollY);
                    console.log("currentPosition", window.scrollY);
                    setCurrentIron({
                      ironClass: color.ironClass,
                      ironColor: color.ironColor,
                      ironLabel: color.ironLabel,
                      ironLabel2: color.ironLabel2,
                      ironLabel3: color.ironLabel3,
                      image1: color.image1,
                      image2: color.image2,
                      image3: color.image3,
                      preferredClub: color.preferredClub,
                      ironKey: color.ironKey
                    });
                    console.log("image1", color.image1);
                    setIronDataModal(true);
                  }}
                >
                  Open
                </button>
              </div>
            ))}

            <div className="save-attach d-flex align-items-center justify-content-between mt-3 mb-4 col-12">
              <button
                className="btn save-attach-btn col-12 py-4"
                disabled={!(remoteData?.irondata?.saveIronStatus == true && remoteData?.irondata?.status == false)}
                style={{ backgroundColor: "rgb(153, 234, 36)" }}
                onClick={() => savetoirontest()}
              >
                Save Iron Testing
              </button>
            </div>
          </div>

          {currentIron != null && (
            <Modal
              show={ironDataModal}
              onHide={handleIronDataPopupHide}
              onShow={handleIronDataPopupShow}
              centered
              className="custom-modal"
            >
              <Modal.Body className="modal-content" style={{ padding: "0" }}>
                <div className=" ">
                  <div className="">
                    <div className="scrollable-content">
                      <div className="main-page-body-content-body">
                        <div className="main-page-body-content-body-container">
                          <div className="container-fluid">
                            <div>
                              <div className="back-home d-flex align-items-center justify-content-between mt-3 mb-4">
                                <button
                                  className="d-flex align-items-center justify-content-center btn col-12 py-4"
                                  onClick={handleCloseModal}
                                  style={{
                                    backgroundColor: "#1e2025",
                                    color: currentIron.ironColor,
                                  }}
                                >
                                  <RiCloseFill
                                    className="ri-close me-2"
                                    size={50}
                                  />
                                  <p>Exit Iron</p>
                                  <div>Back Home</div>
                                </button>
                              </div>

                              <div className="step-content">
                                <div className="step-content-item-2 step-content-item-active  w-100 step-1">
                                  <div className="step">
                                    <div
                                      className={`sec-header-dash ${currentIron.ironClass}`}
                                    >
                                      <div
                                        className="box-title mb-0"
                                        style={{ color: currentIron.ironColor }}
                                      >
                                        <h3>
                                          <span className="color circle-icon"></span>{" "}
                                          {currentIron.ironLabel} Irons
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="new-design-border-sec">
                                <div className="bg_color_dark">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="justify-content-center">
                                        <div className="">
                                          <div
                                            className={`sec-header-dash border-header-sec ${currentIron.ironClass}`}
                                          >
                                            <div
                                              className="box-title mb-0"
                                              style={{
                                                color: currentIron.ironColor,
                                              }}
                                            >
                                              <h3 className="box-title-lable">
                                                <span className="color">1</span>{" "}
                                                {currentIron.ironLabel} Iron
                                              </h3>
                                            </div>
                                          </div>
                                          <div className="desc">
                                            <p>
                                              Match up the club faces and upload a photo below with all three shots for us to analyze strike location.
                                            </p>
                                          </div>
                                          <div
                                            className="card-video"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              className="drop_boxxx"
                                              onClick={() =>
                                                handleCameraModalShow(1, "iron1", currentIron.ironLabel2, currentIron.ironLabel3)
                                              }
                                            >
                                              <input
                                                type="file"
                                                accept=".mp4,.avi,.mkv"
                                                id={`swing1.fileID1`}
                                                style={{ display: "none" }}
                                                name="iron1"
                                              />
                                              {currentIron.image1 && (
                                                <div className="form">
                                                  <img
                                                    className="uploaded-image"
                                                    key={currentIron.image1}
                                                    src={getfullpath(currentIron.image1)}
                                                    alt="selectedImage"
                                                    style={{ width: "100%" }}
                                                  />
                                                </div>
                                              )}
                                              <div className="custom-upload-btn">
                                                <Form.Label
                                                  className={`btn btn-colr-white add-photo-btn w-100`}
                                                >
                                                  Add photo
                                                </Form.Label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="new-design-border-sec">
                                <div className="bg_color_dark">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="justify-content-center">
                                        <div className="">
                                          <div
                                            className={`sec-header-dash border-header-sec ${currentIron.ironClass}`}
                                          >
                                            <div
                                              className="box-title mb-0"
                                              style={{
                                                color: currentIron.ironColor,
                                              }}
                                            >
                                              <h3 className="box-title-lable">
                                                <span className="color">2</span>{" "}
                                                {currentIron.ironLabel} Iron
                                              </h3>
                                            </div>
                                          </div>
                                          <div className="desc">
                                            <p>
                                              Match up the club faces and upload a photo below with all three shots for us to analyze strike location.
                                            </p>
                                          </div>
                                          <div
                                            className="card-video"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              className="drop_boxxx"
                                              onClick={() =>
                                                handleCameraModalShow(2, "iron2", currentIron.ironLabel2, currentIron.ironLabel3)
                                              }
                                            >
                                              <input
                                                type="file"
                                                accept=".mp4,.avi,.mkv"
                                                id={`swing1.fileID2`}
                                                style={{ display: "none" }}
                                                name="iron2"
                                              />
                                              {currentIron.image2 && (
                                                <div className="form">
                                                  <img
                                                    className="uploaded-image"
                                                    key={currentIron.image2}
                                                    src={getfullpath(currentIron.image2)}
                                                    alt="selectedImage"
                                                    style={{ width: "100%" }}
                                                  />
                                                </div>
                                              )}
                                              <div className="custom-upload-btn">
                                                <Form.Label
                                                  className={`btn btn-colr-white add-photo-btn w-100`}
                                                >
                                                  Add photo
                                                </Form.Label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="new-design-border-sec">
                                <div className="bg_color_dark">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div className="justify-content-center">
                                        <div className="">
                                          <div
                                            className={`sec-header-dash border-header-sec ${currentIron.ironClass}`}
                                          >
                                            <div
                                              className="box-title mb-0"
                                              style={{
                                                color: currentIron.ironColor,
                                              }}
                                            >
                                              <h3 className="box-title-lable">
                                                <span className="color">3</span>{" "}
                                                {currentIron.ironLabel} Iron
                                              </h3>
                                            </div>
                                          </div>
                                          <div className="desc">
                                            <p>
                                              Match up the club faces and upload a photo below with all three shots for us to analyze strike location.
                                            </p>
                                          </div>
                                          <div
                                            className="card-video"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              className="drop_boxxx"
                                              onClick={() =>
                                                handleCameraModalShow(3, "iron3", currentIron.ironLabel2, currentIron.ironLabel3)
                                              }
                                            >
                                              <input
                                                type="file"
                                                accept=".mp4,.avi,.mkv"
                                                id={`swing1.fileID3`}
                                                style={{ display: "none" }}
                                                name="iron3"
                                              />
                                              {currentIron.image3 && (
                                                <div className="form">
                                                  <img
                                                    className="uploaded-image"
                                                    key={currentIron.image3}
                                                    src={getfullpath(currentIron.image3)}
                                                    alt="selectedImage"
                                                    style={{ width: "100%" }}
                                                  />
                                                </div>
                                              )}
                                              <div className="custom-upload-btn">
                                                <Form.Label
                                                  className={`btn btn-colr-white add-photo-btn w-100`}
                                                >
                                                  Add photo
                                                </Form.Label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="border-sec">
                                <div
                                  className={`sec-header-dash border-header-sec ${currentIron.ironClass}`}
                                >
                                  <div
                                    className="d-flex box-title mb-0"
                                    style={{ color: "" }}
                                  >
                                    <div
                                      className={`head_check color ${currentIron.preferredClub ? "active" : ""
                                        }`}
                                      style={{
                                        backgroundColor: currentIron.ironColor,
                                      }}
                                    >
                                      <FaHeart style={{ color: "#000000" }} />
                                    </div>
                                    <h3 className="box-title-lable">
                                      <span className="color-image"></span>
                                      Preferred Club
                                    </h3>
                                  </div>
                                </div>
                                <div className="desc">
                                  <p>
                                    Tell us what club that felt best to you while
                                    testing this color by selecting it below. This
                                    is 100% preference.
                                  </p>
                                </div>
                                <div className="btn-sec">
                                  <div className="btn-list">
                                    <button
                                      className={`btn-one btn-colr-white ${currentIron.preferredClub == "1" ? 'active' : ''}`}
                                      onClick={() =>
                                        updatePreferredClub(1)
                                      }
                                    >
                                      {currentIron.ironLabel} 1
                                    </button>
                                    <button
                                      className={`btn-one btn-colr-white ${currentIron.preferredClub == "2" ? 'active' : ''}`}
                                      onClick={() =>
                                        updatePreferredClub(2)
                                      }
                                    >
                                      {currentIron.ironLabel} 2
                                    </button>
                                    <button
                                      className={`btn-one btn-colr-white ${currentIron.preferredClub == "3" ? 'active' : ''}`}
                                      onClick={() =>
                                        updatePreferredClub(3)
                                      }
                                    >
                                      {currentIron.ironLabel} 3
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="d-flex align-items-center justify-content-between mt-3 mb-4 col-12">
                                <button
                                  className="btn col-12 py-4"
                                  type="submit"
                                  onClick={() => handleSaveIron(currentIron.ironClass, currentIron.ironKey)}
                                  disabled={currentIron.preferredClub == "" || currentIron.image1 == "" || currentIron.image2 == "" || currentIron.image3 == ""}
                                  style={{ backgroundColor: "#99EA24" }}
                                >
                                  Save Iron
                                </button>
                              </div>

                              <div className="back-home d-flex align-items-center justify-content-between  mb-4">
                                <button
                                  className="d-flex align-items-center justify-content-center btn col-12 py-4"
                                  onClick={handleCloseModal}
                                  style={{
                                    backgroundColor: "#1e2025",
                                    color: currentIron.ironColor,
                                  }}
                                >
                                  <RiCloseFill
                                    className="ri-close me-2"
                                    size={50}
                                  />
                                  <p>Exit Iron</p>
                                  <div>Back Home</div>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <style>
                    {`
                      @media only screen and (min-width: 320px) and (max-width: 480px) {
                        .drop_box .uploaded-image {
                          height: auto !important;
                        }
                      }
                    `}
                  </style>
                </div>
              </Modal.Body>
            </Modal>
          )}
            <Modal
            show={ironDataModal1}
            centered
            className="step card-radius popup-modal-dark"
        >
            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile" style={{ padding:'4px 15px' }}>
            <div className='row d-flex justify-content-between align-items-center' >
                                    <img className='col-9 text-white remote-text mt-4' src={require("../../../assets/images/remote-fitting-logo.png")} alt="logo" />
                                    <div className="col-3 closing-icon d-flex align-items-center justify-content-end">
                                        {/* <IoClose
                                            color="#ffffff"
                                            onClick={handleCloseModal}
                                        /> */}
                                        <button type="button" className="btn-close" style={{ backgroundColor: 'transparent', border: 'none' }} onClick={handleCloseModal1} aria-label="Close">
                                            <IoClose style={{ strokeWidth: '30px' }}/>
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className='col-12 mb-0'>
                                        <div className="ifream-video-box ratio iframe_wrapper" style={{ paddingBottom: '177.78%' }}>
                                            <div id="player" className="v-video">
                                                <iframe
                                                    ref={(el) => (playerRefs.current[0] = el)}
                                                    src="https://player.vimeo.com/video/1045495817?badge=0&autopause=0&player_id=0&app_id=58479&controls=1"
                                                    frameBorder="0"
                                                    allow="autoplay; fullscreen; picture-in-picture"
                                                    allowFullScreen
                                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                                    title="Your Video Title"
                                                    data-ready="true"
                                                ></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </div>
            </Modal.Body>
        </Modal>

          {currentCameraData != null && (
            <CameraModal
              show={showCameraModal}
              handleClose={handleCameraModalClose}
              setPhotoInBox={updatePhotoInBox}
              ironId={currentCameraData.ironid}
              ironTitle={currentCameraData.irontitle}
              ironLabel={currentCameraData.ironLabel}
              title={currentCameraData.title}
            />
          )}
        </>)
      }

    </>


  );
};

export default IronData;
